import { useCallback } from 'react'
import { loadApplicationCertificateTypeProgramTypes } from './ApplicationCertificateTypeProgramTypeStore'
import { loadCountries } from './CountriesStore'
import { loadCourses } from './CoursesStore'
import { loadEducationalSystems } from './EducationSystemsStore'
import { loadEducationTypes } from './EducationTypesStore'
import {loadEnrollmentTerm} from "./EnrollmentTermStore";
import { loadPartnerSchoolTypes } from './PartnerSchoolTypeStore'
import { loadPrograms } from './ProgramsStore'
import { loadProgramTypes } from './ProgramTypesStore'
import { loadScholarshipFinancialSupports } from './ScholarshipsFinancialSupporsStore'
import { loadScholarshipStatuses } from './ScholarshipStatusStore'
import { loadScholarshipTypes } from './ScholarshipTypesStore'
import { loadSupplementalMaterialTypes } from './SupplementalMaterialTypesStore'
import { loadAdminNonRegularRelayCancelTemplates } from '../../admin/stores/application/TemplateOptionsStore'

export function useOptionStores() {
  const loadOptions = useCallback(async () => {
    loadApplicationCertificateTypeProgramTypes().then()
    loadEducationTypes().then()
    loadEducationalSystems().then()
    loadCourses().then()
    loadCountries().then()
    loadPartnerSchoolTypes().then()
    loadPrograms().then()
    loadProgramTypes().then()
    loadScholarshipFinancialSupports().then()
    loadScholarshipStatuses().then()
    loadScholarshipTypes().then()
    loadSupplementalMaterialTypes().then()
    loadEnrollmentTerm().then()
    loadAdminNonRegularRelayCancelTemplates().then()
  }, [])

  return { loadOptions }
}
